import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-heart-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  爱妻艺
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                让爱有艺术，让妻子更幸福。专注于夫妻关系经营的艺术与智慧。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-booklet-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                文章分类
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">
                    使用条款
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                联系我们
              </h4>
              <ul className="flex flex-col gap-3">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-background-400">hello@mhowiub.cn</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-background-400">北京市朝阳区建国路88号</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-background-400">010-8888-6666</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2026 爱妻艺. All rights reserved.
            </p>
            <p className="text-sm text-background-500">
              让每一段婚姻都充满爱的艺术
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}